import Component from '../abstracts/Component';
export default class SearchLayerComponent extends Component {
  get SELECTORS() {
    return {
      closeButton: '[data-close-search]',
      closeButtonCro: '[data-close-search-cro]',
      searchInput: '[data-header-search-bar-input-field]',
      searchForm: '[data-header-search-form]',
      headerNavActions: '[data-menu-nav-actions]',
      headerNavLinks: '[data-menu-nav-links]',
      mainHeaderLogoContainer: '[data-main-header-logo-container]',
      searchWrapperCro: '[data-header-search-wrapper]',
    };
  }

  get CONSTANTS() {
    return {
      CLASS_METHOD_BY_ACTION: {
        open: 'add',
        close: 'remove',
      },
    };
  }

  get CLASSES() {
    return {
      openClass: '--open',
      openedClass: '--opened',
      hideLogo: '--hide-logo',
      hideLinks: '--hide-links',
      hideActions: '--hide-actions',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.dom = {
      closeButton: this.$component.querySelector(this.SELECTORS.closeButton),
      closeButtonCro: this.$component.querySelector(
        this.SELECTORS.closeButtonCro
      ),
      searchWrapperCro: document.querySelector(this.SELECTORS.searchWrapperCro),
      searchInput: this.$component.querySelector(this.SELECTORS.searchInput),
      searchForm: this.$component.querySelector(this.SELECTORS.searchForm),
      headerNavActions: document.querySelector(this.SELECTORS.headerNavActions),
      headerNavLinks: document.querySelector(this.SELECTORS.headerNavLinks),
      mainHeaderLogoContainer: document.querySelector(
        this.SELECTORS.mainHeaderLogoContainer
      ),
    };
  }

  handleSearchIconAction(action = 'open') {
    if (this.dom?.headerNavActions?.classList)
      this.dom.headerNavActions.classList[
        this.CONSTANTS.CLASS_METHOD_BY_ACTION[action]
      ](this.CLASSES.hideActions);
    if (this.dom?.headerNavLinks?.classList)
      this.dom.headerNavLinks.classList[
        this.CONSTANTS.CLASS_METHOD_BY_ACTION[action]
      ](this.CLASSES.hideLinks);
  }

  handleLayerOpen() {
    this.$component.classList.add(this.CLASSES.openClass);
    if (
      this.dom?.mainHeaderLogoContainer?.classList &&
      this.dom?.mainHeaderLogoContainer?.classList.contains(
        this.CLASSES.hideLogo
      )
    )
      this.dom.mainHeaderLogoContainer.classList.remove(this.CLASSES.hideLogo);
    this.handleSearchIconAction('open');
    this.$emit(this.$customEvents.BACKDROP_EVENTS.show, {
      theme: 'white',
      disableGlobalOverflow: true,
    });
    if (this.dom.searchInput) {
      this.dom.searchInput.value = '';
      this.dom.searchInput.focus();
    }
  }

  handleLayerClose() {
    this.$component.classList.remove(this.CLASSES.openClass);
    this.handleSearchIconAction('close');
    this.$emit(this.$customEvents.SEARCH_LAYER_EVENTS.close);
    this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
    this.$emit(this.$customEvents.BENEFIT_BAR_EVENTS.show);
  }

  bindEvents() {
    //handle layer open
    this.$on(this.$customEvents.SEARCH_LAYER_EVENTS.click, () => {
      if (this.$component.classList.contains(this.CLASSES.openClass))
        this.handleLayerClose();
      else this.handleLayerOpen();
    });

    this.$on(this.$customEvents.SEARCH_LAYER_EVENTS.hide, () => {
      if (this.$component.classList.contains(this.CLASSES.openClass)) {
        this.$component.classList.remove(this.CLASSES.openClass);
        this.$emit(this.$customEvents.BENEFIT_BAR_EVENTS.show);
        this.handleSearchIconAction('close');
      }
    });

    this.$on(this.$customEvents.BACKDROP_EVENTS.close, () => {
      this.handleLayerClose();
    });

    //handle layer close
    this.dom.closeButton?.addEventListener('click', () => {
      this.handleLayerClose();
    });

    //handle layer close
    this.dom.closeButtonCro?.addEventListener('click', () => {
      if (this.dom.searchWrapperCro) {
        this.dom.searchWrapperCro.classList.remove(this.CLASSES.openedClass);
      }
    });

    // handle form submit
    this.dom.searchForm?.addEventListener('submit', (event) => {
      if (this.dom.searchInput && this.dom.searchInput.value.length <= 0) {
        event.preventDefault();
        this.dom.searchInput.focus();
      }
    });
  }

  render() {
    super.render();
    this.bindEvents();
  }
}
